import { Link, Typography } from '@mui/material';
import React from 'react';
import { GradientPage } from './GradientPage.styles';
import { LockIllustration } from './LockIllustration.styles';
import { useAccessDeniedViewController } from '../../controllers';

export const AccessDeniedView = () => {
  const { navigateToLogin } = useAccessDeniedViewController();

  return (
    <GradientPage>
      <LockIllustration />
      <div>
        <Typography
          component="h1"
          fontSize="2em"
          fontWeight="fontWeightBold"
          textAlign="center"
          mt={5}
          mb={2.5}
        >
          Access denied.
        </Typography>
        <Typography component="p" textAlign="center" mt={5} mb={2.5}>
          You do not currently have access to any companies on the platform.
        </Typography>
        <Typography component="p" textAlign="center" mt={5} mb={2.5}>
          <Link href="#" onClick={navigateToLogin}>
            Back to Login
          </Link>
        </Typography>
      </div>
    </GradientPage>
  );
};
